import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPinterest,
    faFacebookF,
    faInstagram,
    faYoutube,
    faLinkedinIn,
    faQuora,
    faReddit
} from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <div className="footer">
            <div className="firstfooter">
                <div className="innerone">
                    <h3>tooliso</h3>
                    <i>Your one-stop solution for free online utility tools. Simple, fast, and reliable.</i>
                    <div className="footertag">
                        <a target="_blank" rel="noopener noreferrer" href="https://www.pinterest.com/tooliso/"><FontAwesomeIcon icon={faPinterest} /></a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=61575015327469"><FontAwesomeIcon icon={faFacebookF} /></a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/tooliso.com_?igsh=eWRudHhqMGo0dXF6"><FontAwesomeIcon icon={faInstagram} /></a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/tooliso/?viewAsMember=true"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.quora.com/profile/Tooliso"><FontAwesomeIcon icon={faQuora} /></a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.reddit.com/user/Toolisopro/"><FontAwesomeIcon icon={faReddit} /></a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/@Tooliso100"><FontAwesomeIcon icon={faYoutube} /></a>
                    </div>
                </div>
                <div className="innertwo">
                    <h3 style={{margin:"5px"}}>Company</h3>
                    <Link style={{position:"relative", left:"5px",top:"10px"}} to={'/AboutUs'}>About Us</Link>
                    <Link style={{position:"relative", left:"5px",top:"10px"}} to={'/Blogs'}>Blogs</Link>
                    <Link style={{position:"relative", left:"5px",top:"10px"}} to={'/contact'}>Contact</Link>
                    <Link style={{position:"relative", left:"5px",top:"10px"}} to={'/privacyPolicy'}>Privacy Policy</Link>
                </div>
            </div>
            <div className="copyright">
            © 2023 Tooliso. All rights reserved.
            </div>
        </div>

    )
}
